/**
 * Studio-Scrollys POSITIV erkennen — EINE Regel für App (Werkzeug-Badges,
 * scrolly-format.ts) und geteilten Renderer (Backdrop-Dämpfung).
 *
 * Alle Studio-Generatoren (compose, ken-burns, interactive-map, static-map,
 * photo-story, sentence-bloom, counter) schreiben einen eigenen Ersteller ins
 * JSON — `creator.id` mit `studio-`-Präfix (studio-ai / studio-template /
 * studio-photo-story / studio-counter-hamburg). Das ist der einzige
 * verlässliche Studio-Marker; je nach Generator camelCase oder snake_case,
 * deshalb beide Pfade.
 *
 * WARUM NICHT `templateStructure` oder `templateId` (Jans Funde 03./06.08.2026):
 * `templateStructure` schreiben Studio UND Template-Editor — sie trennt die
 * Welten nicht. `templateId` hängt an `onDelete: SetNull` und verschwindet
 * mit der gelöschten Vorlage. Nur der Ersteller bleibt.
 */
export function istStudioScrolly(json: unknown): boolean {
    if (!json || typeof json !== "object") return false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const j = json as any;
    const creator = j.creator ?? j.data?.creator ?? j.data?.data?.creator;
    if (!creator || typeof creator !== "object") return false;
    const id = creator.id ?? creator._id;
    if (typeof id === "string" && id.toLowerCase().startsWith("studio-")) return true;
    const vorname = creator.firstName ?? creator.first_name;
    return typeof vorname === "string" && vorname.toLowerCase() === "studio";
}
